export enum StoreKey {
  CALENDARS = 'calendars',
  CONTACT_PERSONS = 'contact-persons',
  MARKET_CODES = 'market-codes',
  PROPERTY_MARKET_CODES = 'property-market-codes',
  CUSTOMER_RESERVATIONS = 'customer-reservations',
  CONTACT_PERSON_LOG = 'contact-person-log',
  GUEST_LOG = 'guest-log',
  COMPANIES = 'companies',
  COMPANIES_SUGGEST = 'companies-suggest',
  SWITCH_PROPERTY = 'switch-property',
  PROPERTY_STAY_PACKAGES = 'property-stay-packages',
  PROPERTY_SERVICES = 'property-services',
  PROPERTY_BANK_ACCOUNTS = 'property-bank-accounts',
  PROPERTY_TERMINALS = 'property-terminals',
  PRICING_COUPONS = 'pricing-coupons',
  PRICING_TAX_PERIODS = 'pricing-tax-periods',
  PRICING_RATE_PLANS = 'property-rate-plans',
  PRICING_ONLINE_RESERVATION_DEFAULT_RATE_PLANS = 'property-default-rate-plans',
  PRICING_MEAL_RATE_PLANS = 'property-meal-rate-plans',
  PRICING_TAX_SETTINGS = 'pricing-tax-settings',
  OBJECT_ROOMS_AVAILABILITY = 'object-rooms-availability',
  OBJECT_ROOMS_AVAILABILITY_FILTER_AVAILABLE = 'object-rooms-availability-filter-available',
  CREATE_RESERVATION = 'create-reservation',
  OFFERS = 'offers',
  OFFER_CREATE = 'offer-create',
  PROPERTY = 'property',
  PROPERTIES = 'properties',
  USER = 'user',
  USERS = 'users',
  ROLES = 'roles',
  INVOICING_DOCUMENTS = 'invoicing-documents',
  INVOICING_L10N = 'invoicing-l10n',
  INVOICING_GIFT_VOUCHERS = 'invoicing-gift-vouchers',
  INVOICING_GIFT_VOUCHER_NUMBER_SERIES = 'invoicing-gift-voucher-number-series',
  INVOICING_NUMBERINGS = 'invoicing-numberings',
  INVOICING_SUPPLIERS = 'invoicing-suppliers',
  UNPAID_DOCUMENTS = 'unpaid-documents',
  CLOSURES = 'closures',
  GUESTS = 'guests',
  GUEST_TAGS = 'guest-tags',
  GUEST_GROUP_PROPERTIES = 'guest-group-properties',
  HOUSEKEEPING_CLEANING = 'housekeeping-cleaning',
  HOUSEKEEPING_DEFECTS = 'housekeeping-defects',
  HOUSEKEEPING_TASKS = 'housekeeping-tasks',
  HOUSEKEEPING_TASK_TEMPLATES = 'housekeeping-task-templates',
  HOUSEKEEPING_ROOM_ASSIGNMENTS = 'housekeeping-room-assignments',
  HOUSEKEEPING_OBJECT_ROOM_TIDINESS = 'housekeeping-object-room-tidiness',
  HOUSEKEEPING_OBJECT_ROOM_TASKS = 'housekeeping-object-room-tasks',
  HOUSEKEEPING_OBJECT_ROOM_DEFECTS = 'housekeeping-object-room-defects',
  HOUSEKEEPING_CLEANING_SETTINGS = 'housekeeping-cleaning-settings',
  REPORTS_NTAK = 'reports-ntak',
  PAYMENTS = 'payments',
  ONLINE_RESERVATION_FORM_CONFIGURATIONS = 'online-reservation-form-configurations',
  ONLINE_RESERVATION_FORM_CONFIGURATION = 'online-reservation-form-configuration',
  ONLINE_RESERVATION_PROPERTY_INFO = 'online-reservation-property-info',
  PROPERTY_SETTINGS_BOOK_ONLINE = 'property-settings-book-online',
  RESERVATION_LIST = 'reservation-list',
  RESERVATION_DETAIL = 'reservation-detail',
  RESERVATION_DETAIL_FOLIO = 'reservation-detail-folio',
  RESERVATION_DETAIL_OVERVIEW = 'reservation-detail-overview',
  RESERVATION_DETAIL_ROOMS = 'reservation-detail-rooms',
  RESERVATION_DETAIL_VENUES = 'reservation-detail-venues',
  RESERVATION_DETAIL_TASKS = 'reservation-detail-tasks',
  RESERVATION_DETAIL_ATTACHMENTS = 'reservation-detail-attachments',
  RESERVATION_DETAIL_STATUS = 'reservation-detail-status',
  RESERVATION_DETAIL_TERM = 'reservation-detail-term',
  RESERVATION_DETAIL_KEYS_OVERVIEW = 'reservation-detail-keys-overview',
  RESERVATION_DETAIL_KEYS = 'reservation-detail-keys',
  RESERVATION_DETAIL_LOCK_CAPABILITIES = 'reservation-detail-lock-capabilities',
  RESERVATION_DETAIL_COMMUNICATION = 'reservation-detail-communication',
  RESERVATION_GUEST_FORM = 'reservation-guest-form',
  RESERVATION_EDIT_ROOMS = 'reservation-edit-rooms',
  ROUNDING_EXCEPTION = 'rounding-exception',
  COMMUNICATION_TEMPLATE_CAMPAIGN = 'communication-template',
  COMMUNICATION_TEMPLATE_CAMPAIGN_SETTING = 'communication-template-setting',
  COMMUNICATION_MARKET_CODE_STORE = 'communication-market-codes',
  COMMUNICATION_PLACEHOLDERS_STORE = 'communication-placeholders',
  COMMUNICATION_GUEST_TAGS_STORE = 'communication-guest-tags',
  COMMUNICATION_SERVICE_IN_ACCOUNT_STORE = 'communication-service-in-account',
  COMMUNICATION_STOCK_ITEMS_STORE = 'communication-stock-items',
  COMMUNICATION_RECIPIENTS_STORE = 'communication-recipients-items',
  COMMUNICATION_STAY_PACKAGE_STORE = 'communication-stay-packages',
  COMMUNICATION_COMPANY_STORE = 'communication-company',
  COMMUNICATION_ATTACHMENT_MIME_TYPES_STORE = 'communication-attachment-mime-types',
  COMMUNICATION_TEMPLATE_MESSAGE_SENT = 'communication-template-message-sent',
  PROPERTY_FEE_PERFORMANCE = 'property-fee-performance',
  PROPERTY_ALFRED_SETTINGS = 'property-alfred-settings',
  PROPERTY_WHATSAPP_AVAILABILITY = 'property-whatsapp-availability',
  ALFRED_SETTINGS = 'alfred-settings',
  ALFRED_SETTINGS_PROPERTY_INFO = 'alfred-settings-property-info',
  ALFRED_SETTINGS_TRIP_TIPS = 'alfred-settings-trip-tips',
  COUNTRY_INVOICE_FIELDS = 'country-invoice-fields',
  COMPANY_TAGS = 'company-tags',
  COMPANY_ACTIVITY = 'company-activity',
  SELF_SERVICE_BAR = 'self-service-bar',
  SELF_SERVICE_BAR_PROPERTY_INFO = 'self-service-bar-property-info',
  POS_TABLES = 'pos-tables',
  ROOM_CONNECTIONS = 'room-connections',
  CONNECTED_ROOMS_SETTINGS = 'connected-rooms-settings',
  CONNECTED_ROOMS_FAILURES = 'connected-rooms-failures',
  PROPERTY_OBJECT_ROOMS = 'property-object-rooms',
  PROPERTY_PARTNERS = 'property-partners',
  SETTINGS_GUEST_TAGS = 'settings-guest-tags',
  SETTINGS_COMPANY_TAGS = 'settings-company-tags',
  SETTINGS_LOCKSYSTEM_SETUP = 'settings-lockSystem-setup',
  SETTINGS_LOCKSYSTEM_SETTINGS = 'settings-lockSystem-settings',
  OTA_CONNECTIONS_LIST = 'ota-connections-list',
  OTA_RATE_PLANS = 'ota-rate-plans',
  OTA_SERVICE_MAPPING_LIST = 'ota-service-mapping-list',
  RESERVATION_NOTIFICATION_SETTINGS = 'reservation-notification-settings',
  ACCOUNTING_SOFTWARE_EXPORT_SETTING = 'accounting-software-export-setting',
  DOCUMENTS_NUMBER_SERIES = 'documents-number-series',
  PAYMENT_NUMBERING = 'payment-numbering',
  SETTINGS_RESERVATION_GENERAL = 'settings-reservation-general',
  SETTINGS_RESERVATION_FOLIO = 'settings-reservation-folio',
  SETTINGS_RESERVATION_VOUCHER = 'settings-reservation-voucher',
  SETTINGS_HOTEL_EMAIL = 'settings-hotel-email',
  SETTINGS_HOTEL_WHATSAPP = 'settings-hotel-whatsapp',
  SETTINGS_HOTEL_CURRENCIES = 'settings-hotel-currencies',
  SETTINGS_ACCEPTED_PAYMENT_TYPES = 'settings-accepted-payment-types',
  VAT_BREAKDOWN_SETTINGS = 'vat-breakdown-settings',
  CALENDAR_OVERVIEW = 'calendar-overview',
  CALENDAR_QUICK_OVERVIEW = 'calendar-quick-overview',
  CALENDAR_AVAILABILITY = 'calendar-availability',
  CALENDAR_UNASSIGNED = 'calendar-unassigned',
  CALENDAR_RESERVATION_SUGGESTER = 'calendar-reservation-suggester',
  STAT_OFFICE_REPORT_CZ = 'stat-office-report-cz',
  SETTINGS_DASHBOARD = 'settings-dashboard',
  AI_CHAT = 'ai-chat',
  AI_ADVISOR = 'ai-advisor',
}
